import {
	GET_ROLES,
	GET_USER_ROLES,
	EDIT_USER_ROLES,
	GET_PERMISSIONS,
	GET_ROLE_PERMISSIONS,
	GET_USER_PERMISSIONS
} from '../Actions/types';

import { can } from "../../util/functions";

const initSate = {
	roles: [],
	usersRoles: [],
	permissions: [],
	rolePermissions: [],
	userPermissions: []
};

const RoleAndPermissionsReducer = (state = initSate, action) => {

	switch (action.type) {

		case GET_ROLES: {

			let { roles, authUser } = action.payload;
			// roles = roles.filter(r => {
			//   if(r.RoleName === "Guard" || r.RoleName === "Supervisor"){
			//     return true;
			//   }
			//   return can("create-admin-user",authUser.permissions);
			// });


			return { ...state, roles };
		}

		case GET_USER_ROLES: {

			let usersRoles = [...state.usersRoles, {
				id: action.payload.id,
				roles: action.payload.roles
			}];

			return { ...state, usersRoles: usersRoles };
		}

		case EDIT_USER_ROLES: {

			let usersRoles = state.usersRoles.map(ur => {
				if (ur.id !== action.payload.id) {
					return { ...ur };
				}
				return { ...ur, roles: action.payload.roles };
			});

			return { ...state, usersRoles: usersRoles };
		}

		case GET_PERMISSIONS: {
			return { ...state, permissions: action.payload };
		}

		case GET_ROLE_PERMISSIONS: {
			return state;
		}

		case GET_USER_PERMISSIONS: {
			return state;
		}

	}
	return state;
};

export default RoleAndPermissionsReducer;
